/* eslint-disable camelcase */
import React, { useEffect } from 'react'
import { Box, IconButton, InputAdornment } from '@mui/material'
import Grid from '@mui/material/Grid'
import { PropTypes } from 'prop-types'
import BorderColorIcon from '@mui/icons-material/BorderColor'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { useDispatch, useSelector } from 'react-redux'
import InfoIcon from '@mui/icons-material/Info'
import config from '../../config/config'
import { setRoadwayVariables } from '../../slices/generalInputs/roadwayVariables'
import { saveStreetName } from '../../../store/slices/street'
import {
  HIGH_CAPACITY_TRANSIT,
  LAND_USE_CONTEXT,
  ROADWAY_NAME,
  YES
} from '../../constants/roadwayVariables'
import { themeConfig } from '../../config/theme.config'
import { onNewStreetDefaultClick } from '../../../streets/creation'
import { LightTooltip } from '../CriteriaSelection/ModalCriteria'
import { setShareableURL } from '../../slices/appSlice'
import { setModalTiers } from '../../slices/generalInputs/modalTiers'
import { setAllModalPrioritization } from '../../slices/generalInputs/modalPrioritization'
import { TRANSIT } from '../../constants/modalTiers'
import { SubSectionTitle } from './ProjectInputs'
import './ProjectInputs.scss'
const step1Illustration = new URL(
  '../../../../images/illustrations/step1-2x.png',
  import.meta.url
)

export const Container = ({ children, mt = '0px', width = '50%' }) => {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width,
        mt
      }}
      className="individual-container"
    >
      {children}
    </Box>
  )
}

export default function ProjectInputsTwo() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        height: '400px',
        gap: '10px'
      }}
      className="project-inputs-main-container"
    >
      <Box
        sx={{
          width: '30%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        className="img-container"
      >
        <img
          src={step1Illustration}
          style={{ objectFit: 'contain', maxWidth: '100%', maxHeight: '100%' }}
        />
      </Box>
      <Box
        sx={{
          width: '60%',
          display: 'grid',
          gridTemplateRows: '50% 50%'
        }}
        className="inputs-one-container"
      >
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            mt: '20px'
          }}
        >
          {config.roadwayVariables
            .filter((obj, i) => i <= 2)
            .map((roadWayInput) => {
              if (
                roadWayInput.inputType === 'string' ||
                roadWayInput.inputType === 'number'
              ) {
                return (
                  <CustomTextField
                    field={roadWayInput.field}
                    question={roadWayInput.title}
                    key={`${roadWayInput.field}-textfield`}
                    type={roadWayInput.inputType}
                    placeholder={roadWayInput.placeholder}
                    inputProps={roadWayInput.inputProps}
                  />
                )
              }
            })}
        </Box>
        <Box
          sx={{
            display: 'flex',
            width: '100%'
          }}
        >
          {config.roadwayVariables
            .filter((obj, i) => i <= 3)
            .map((roadWayInput) => {
              switch (roadWayInput.inputType) {
                case 'dropDown':
                  return (
                    <CustomDropDown
                      field={roadWayInput.field}
                      question={roadWayInput.title}
                      key={`${roadWayInput.field}-slider`}
                      dropDownValues={roadWayInput.values}
                      notes={roadWayInput.notes}
                    />
                  )

                default:
              }
            })}
        </Box>
      </Box>
    </Box>
  )
}

export function CustomDropDown({ field, question, dropDownValues, notes }) {
  const inputValue = useSelector((state) => state.roadwayVariables[field])
  const { roadway_name, high_capacity_transit } = useSelector(
    (state) => state.roadwayVariables
  )
  const { shareableURL } = useSelector((state) => state.appSlice)
  const { modalPrioritization } = useSelector((state) => state)
  const dispatch = useDispatch()

  function handleClick(value) {
    // If URL is shareable, then remix street whenever a field is changed
    if (shareableURL) {
      // remixStreet() -> street remix is done is App.jsx whenever shareableURL is false
      dispatch(setShareableURL(false))
    }
    dispatch(setRoadwayVariables({ field, value }))
    if (field === LAND_USE_CONTEXT) {
      onNewStreetDefaultClick(value)
      dispatch(saveStreetName(roadway_name, true))
    }
    const priorityArr = Object.values(modalPrioritization)

    // Remove the transit from the priority list

    // If the feild is High capacity transit and vlaue is yes, then set Transit to tier 1 and Prioiryt of transit to 1
    if (field === HIGH_CAPACITY_TRANSIT && value === YES) {
      // Make sure transit is not already prioirty 1
      if (priorityArr[0]?.name !== TRANSIT) {
        dispatch(setModalTiers({ field: TRANSIT, value: 1 }))

        const transitIndex = priorityArr.findIndex((val) => val === TRANSIT)
        priorityArr.splice(transitIndex, 1)

        dispatch(
          setAllModalPrioritization({
            Priority_1: TRANSIT,
            Priority_2: priorityArr[0]?.name,
            Priority_3: priorityArr[1]?.name,
            Priority_4: priorityArr[2]?.name,
            Priority_5: priorityArr[3]?.name
          })
        )
      }
    }
  }

  return (
    <Grid
      container={true}
      direction="column"
      sx={{
        mt: '0px !important',
        width: '90%'
      }}
    >
      <Grid item={true} sx={{ pt: '0px !important' }}>
        <Box
          sx={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}
        >
          <SubSectionTitle>{question}</SubSectionTitle>
          {notes && (
            <LightTooltip title={notes} placement="top">
              <IconButton>
                <InfoIcon
                  style={{
                    color: config.themeConfig.semcogGreen
                  }}
                />
              </IconButton>
            </LightTooltip>
          )}
        </Box>
      </Grid>

      <Grid
        item={true}
        xs={true}
        sx={
          field === LAND_USE_CONTEXT
            ? {
                pt: '5px !important',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center'
              }
            : { mt: '20px' }
        }
      >
        {dropDownValues.map((value, i) => (
          <Box
            key={`${value}-${i}`}
            sx={
              inputValue === value
                ? {
                    padding: '.25rem 1rem',
                    border: '1px solid  #64983D',
                    margin: '0.3em',
                    cursor: 'pointer',
                    alignSelf:
                      field === LAND_USE_CONTEXT ? 'flex-start' : 'center',
                    backgroundColor: config.themeConfig.semcogGreen,
                    width: field === LAND_USE_CONTEXT ? '85%' : '25%',
                    borderRadius: '15px',
                    // fontStyle: 'italic',
                    fontWeight: 500,
                    mr: '35px'
                  }
                : {
                    padding: '.25rem .75rem',
                    border: '0.1px solid #64983D',
                    backgroundColor: 'white',
                    margin: '0.3em',
                    alignSelf:
                      field === LAND_USE_CONTEXT ? 'flex-start' : 'center',
                    cursor: 'pointer',
                    borderRadius: '15px',
                    width: field === LAND_USE_CONTEXT ? '85%' : '25%',
                    // fontStyle: 'italic',
                    fontWeight: 500,
                    mr: '35px'
                  }
            }
            onClick={() => {
              handleClick(value)
            }}
            component="button"
          >
            <Typography
              variant="body1"
              sx={
                inputValue === value
                  ? {
                      color: config.themeConfig.titleTextColor,
                      fontWeight: 600,
                      textAlign: field === LAND_USE_CONTEXT ? 'left' : 'center'
                    }
                  : {
                      color: config.themeConfig.semcogGreen,
                      fontWeight: 600,
                      textAlign: field === LAND_USE_CONTEXT ? 'left' : 'center'
                    }
              }
            >
              {value}
            </Typography>
          </Box>
        ))}
      </Grid>
    </Grid>
  )
}

function CustomTextField({ field, question, type, placeholder, inputProps }) {
  const inputValue = useSelector((state) => state.roadwayVariables[field])
  const { shareableURL, selectedFeaturesArr } = useSelector(
    (state) => state.appSlice
  )
  const dispatch = useDispatch()

  function handleChange(e) {
    // If URL is shareable, then remix street whenever a field is changed
    if (shareableURL) {
      // remixStreet() -> street remix is done is App.jsx whenever shareableURL is false
      dispatch(setShareableURL(false))
    }
    dispatch(setRoadwayVariables({ field, value: e.target.value }))
  }

  // Set Street name, when project name changes
  useEffect(() => {
    if (field === ROADWAY_NAME) {
      dispatch(saveStreetName(inputValue, true))
    }
  }, [inputValue])

  return (
    <Grid
      container={true}
      spacing={5}
      direction="column"
      sx={{ mt: '0px !important' }}
    >
      <Grid item={true} sx={{ pt: '0px !important' }}>
        <SubSectionTitle>{question}</SubSectionTitle>
      </Grid>

      <Grid item={true} xs={true} sx={{ pt: '5px !important' }}>
        <TextField
          id={field}
          variant="filled"
          value={inputValue === undefined ? '' : inputValue}
          type={type}
          onChange={handleChange}
          inputProps={inputProps || {}}
          sx={{
            width: '80%',
            '& .MuiInputBase-input': {
              background: 'white',
              color: config.themeConfig.semcogDarkGray
            },
            input: {
              '&::placeholder': {
                fontStyle: 'italic'
              }
            }
          }}
          placeholder={placeholder}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <BorderColorIcon sx={{ color: themeConfig.semcogBlue1 }} />
              </InputAdornment>
            )
          }}
        />
        {field === ROADWAY_NAME && (
          <Typography
            gutterBottom={true}
            sx={{
              mt: 1,
              ml: 1.5,
              fontSize: '13px',
              color: config.themeConfig.semcogBlue1
            }}
          >
            Number of segments selected:{' '}
            <strong>{selectedFeaturesArr.length}</strong>
          </Typography>
        )}
      </Grid>
    </Grid>
  )
}

Container.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  mt: PropTypes.string,
  width: PropTypes.string
}
CustomTextField.propTypes = {
  field: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  inputProps: PropTypes.object
}
CustomDropDown.propTypes = {
  field: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  dropDownValues: PropTypes.array.isRequired
}
